<form autocomplete="off">
   <samweb-loading-indicator fxFlexFill [showLoadingCircle]="true" [longRunningContextCategories]="['CHANGE_PASSWORD']">
      <div class="sam-form-row">
         {{ 'common.change-password.info' | translate }}
      </div>

      <div class="sam-form-row">
         <label>{{ 'common.change-password.current-password' | translate }}</label>
         <kendo-textbox
            samwebPasswordTextbox
            placeholder="{{ 'common.change-password.enter-current-password' | translate }}"
            class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width"
            [clearButton]="true"
            [value]="currentPassword$ | async"
            (valueChange)="updateCurrentPassword($event)"
         >
         </kendo-textbox>
      </div>

      <div class="sam-form-row">
         <label>{{ 'common.change-password.new-password' | translate }}</label>
         <kendo-textbox
            samwebPasswordTextbox
            placeholder="{{ 'common.change-password.enter-new-password' | translate }}"
            class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width"
            [clearButton]="true"
            [showSuccessIcon]="isNewPasswordSpecified$ | async"
            [showErrorIcon]="!(isNewPasswordSpecified$ | async)"
            [value]="newPassword$ | async"
            (valueChange)="updateNewPassword($event)"
         >
         </kendo-textbox>
         <kendo-textbox
            samwebPasswordTextbox
            placeholder="{{ 'common.change-password.confirm-new-password' | translate }}"
            class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width sam-margin-top"
            [clearButton]="true"
            [showSuccessIcon]="isNewPasswordConfirmed$ | async"
            [showErrorIcon]="!(isNewPasswordConfirmed$ | async)"
            [value]="confirmedPassword$ | async"
            (valueChange)="updateConfirmedPassword($event)"
         >
         </kendo-textbox>
      </div>

      <div class="sam-form-row">
         <div class="sam-form-control sam-form-control-full-width" fxLayout="row-reverse" fxFlexAlign="end">
            <button
               kendoButton
               [primary]="true"
               [disabled]="!(canChangePasswordNow$ | async)"
               (click)="changePasswordNow()"
            >
               <div class="sam-button-text">
                  {{ 'common.change-password.change-password-button' | translate }}
               </div>
            </button>
         </div>
      </div>

      <div class="sam-form-row">
         <div
            *ngIf="isResultAvailable$ | async"
            [ngClass]="(lastChangeSucceeded$ | async) ? 'succeeded' : 'failed'"
            class="sam-padding-top sam-padding-right sam-padding-bottom change-result"
         >
            <fa-icon
               fxFlex="1 1 40px"
               fxLayoutAlign="center center"
               [icon]="(lastChangeSucceeded$ | async) ? successIcon : errorIcon"
               [fixedWidth]="true"
            ></fa-icon>
            {{ lastChangeMessage$ | async | translate }}
         </div>
      </div>
   </samweb-loading-indicator>
</form>
